"use client";

import Link from "next/link";
import { useContext } from "react";
import { AppContext } from "@/context/AppContext";
import { useData, useLocalePath } from "@/i18n/LangContext";
import LanguageSwitch from "./LanguageSwitch";

// Mobiler Footer: statisch ganz unten im Scrollflow (kein Sticky),
// luftig gestapelt — Sprache, Legal-Links, Copyright.
export default function MobileFooter() {
  const { isOnCvSubdomain } = useContext(AppContext);
  const { ui } = useData();
  const lp = useLocalePath();
  const currentYear = new Date().getFullYear();

  const getHref = (path: string): string => {
    const localized = lp(path);
    if (isOnCvSubdomain) {
      return `https://robinwichmann.com${localized}`;
    }
    return localized;
  };

  return (
    <footer className="mobile-footer md:hidden print:hidden" data-cy="mobile-footer">
      <LanguageSwitch size="lg" />
      <nav className="mobile-footer--links">
        <Link href={getHref("/imprint")} className="footer--link no-select">{ui.footer.imprint}</Link>
        <Link href={getHref("/privacy")} className="footer--link no-select">{ui.footer.privacy}</Link>
      </nav>
      <div className="mobile-footer--copy">© {currentYear} Robin Wichmann</div>
    </footer>
  );
}
